import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { usePrimaryDimensionDataIndexArray } from '../../../../utils/dimensions';
export function DefaultListMapper() {
    var listArray = usePrimaryDimensionDataIndexArray();
    return (React.createElement(React.Fragment, null, listArray.map(function (index) { return (React.createElement(RampWithNameTransform, { key: index, rampName: "ElementBase", index: index })); })));
}
